import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import authService from "services/authService";
import RouteEnum from "constants/RouteEnum";

const policy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const resetToken = sessionStorage.getItem("passwordResetToken");

  useEffect(() => {
    if (!resetToken) navigate(RouteEnum.ForgotPassword, { replace: true });
  }, [resetToken, navigate]);

  const submit = async ({ password }) => {
    setLoading(true);
    try {
      await authService.resetPassword({
        reset_token: resetToken,
        new_password: password,
      });
      sessionStorage.removeItem("passwordResetToken");
      sessionStorage.removeItem("passwordResetEmail");
      notification.success({ message: t("passwordResetComplete") });
      navigate(RouteEnum.Login, { replace: true });
    } catch {
      notification.error({ message: t("invalidResetLink") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-layout d-flex align-items-center justify-content-center">
      <Card title={t("resetPassword")} style={{ width: 440, maxWidth: "94%" }}>
        <Form layout="vertical" onFinish={submit}>
          <Form.Item
            name="password"
            label={t("password")}
            rules={[
              { required: true },
              { pattern: policy, message: t("passwordPolicy") },
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            name="confirm"
            label={t("confirmPassword")}
            dependencies={["password"]}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  return value === getFieldValue("password")
                    ? Promise.resolve()
                    : Promise.reject(new Error(t("passwordsDoNotMatch")));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {t("resetPassword")}
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPassword;
